import { Contract, SharedProps } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Autocomplete, Button, NumberInput, Paper, Stack, Title } from '@mantine/core'
import { useState } from 'react'

function NewCourierOrder({
  contracts,
  current_organization,
}: { contracts: Contract[] } & SharedProps) {
  const [contractSearch, setContractSearch] = useState('')
  const [articleCount, setArticleCount] = useState<number | string>(1)
  const [loading, setLoading] = useState(false)

  const contractOptions = contracts.map((contract) => contract.customer_name)
  const selectedContract = contracts.find((contract) => contract.customer_name === contractSearch)

  const handleSubmit = () => {
    if (!selectedContract) return

    setLoading(true)
    router.post(
      `/organizations/${current_organization!.slug}/couriers/orders`,
      {
        order: {
          contract_id: selectedContract.id,
          article_count: articleCount,
        },
      },
      {
        onFinish: () => setLoading(false),
      }
    )
  }

  const isValid = Boolean(selectedContract) && Number(articleCount) > 0

  return (
    <Stack>
      <Head title={`Nouvelle Commande - ${current_organization!.name}`} />

      <Title>Nouvelle Commande</Title>

      <Paper p="xl" radius="md" withBorder>
        <Stack gap="lg">
          <Autocomplete
            label="Client (Société)"
            placeholder="Rechercher une société..."
            data={contractOptions}
            value={contractSearch}
            onChange={setContractSearch}
            limit={5}
            required
          />

          <NumberInput
            label="Nombre d'articles"
            description="Combien d'articles déposez-vous ?"
            value={articleCount}
            onChange={setArticleCount}
            min={1}
            max={50}
            required
          />

          <Button onClick={handleSubmit} loading={loading} disabled={!isValid} size="md" fullWidth>
            Créer la commande
          </Button>
        </Stack>
      </Paper>
    </Stack>
  )
}

export default NewCourierOrder
